import React, { useState } from "react";
import ServiceCard from "./ServiceCard";
import { Services as services } from "../../utilities/models/ServiceModel";
import { useNavigate } from "react-router-dom";
import { useUserRefresh } from "../user/UserProvider";
import KeycloakService from "../config/KeycloakService";
import PagesEndPoints from "../../utilities/constants/PagesEndpoints";
import Modal from "../../utilities/components/Modal";
import LocalizedModal from "../../utilities/components/LocalizedModal";
import { RESERVATIONS } from "../../utilities/constants/AccountScreen";
import { Sparkles } from "lucide-react";

const ServicePage = () => {
  const navigateTo = useNavigate();
  const [showLoggingDialog, setShowLoggingDialog] = useState(false);
  const setFetchUserFlag = useUserRefresh();

  const singIn = async () => {
    await KeycloakService.doLogin(setFetchUserFlag);
  };

  const handleBookNow = (service) => {
    if (KeycloakService.isLoggedIn()) {
      navigateTo(`${PagesEndPoints.BOOKING_PAGE_URL}/${RESERVATIONS}`, {
        state: { eventType: service.title },
      });
    } else {
      setShowLoggingDialog(true);
    }
  };

  return (
    <div className="min-h-screen bg-white dark:bg-slate-950 transition-colors duration-300">
      {/* --- Header Section --- */}
      <section className="relative py-20 bg-slate-50 dark:bg-slate-900 border-b border-slate-200 dark:border-slate-800">
        <div className="container mx-auto px-6 max-w-7xl text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 text-sm font-bold tracking-widest uppercase mb-6">
            <Sparkles size={14} />
            <span>World-Class Experiences</span>
          </div>
          <h1 className="text-5xl md:text-6xl font-serif font-bold text-slate-900 dark:text-white mb-6">
            Our Signature Services
          </h1>
          <p className="text-xl text-slate-600 dark:text-slate-400 max-w-3xl mx-auto leading-relaxed">
            From intimate gatherings to grand galas, Le Prestige Hall offers the
            perfect backdrop for every chapter of your story.
          </p>
        </div>
      </section>

      {/* --- Services Grid --- */}
      <section className="py-20">
        <div className="container mx-auto px-6 max-w-7xl">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service) => (
              <ServiceCard
                key={service.id}
                service={service}
                bookingHandler={handleBookNow}
              />
            ))}
          </div>
        </div>
      </section>

      {/* --- Login Modal --- */}
      <Modal isOpen={showLoggingDialog} onClose={setShowLoggingDialog}>
        <LocalizedModal
          actionHandler={singIn}
          actionText="Sign In"
          cancelText="Cancel"
          message="Please sign in to book an event."
          setOpen={setShowLoggingDialog}
          title="Sign In Required"
        />
      </Modal>
    </div>
  );
};

export default ServicePage;
